<template>
  <popup :open.sync="open">
    <div class="popup-header">
      <h3>New Scan</h3>
    </div>
    <template>
      <div class="scrollable">
        <template>
          <div class="content-form">
            <div class="form-row form-split">
              <form-field-select v-model="submitForm.scanType" label="Scan Type" :validator="$v.submitForm.scanType" :options="providerOptions" required />
              <form-field-select-search v-model="submitForm.profile" label="Select Profile" :validator="$v.submitForm.profile" :options="accountOptions" required />
            </div>
            <div class="form-row form-fullw justify-content-center">
              <p class="text-center">Notes for Compliance Scans</p>
            </div>
            <br/>
            <div class="form-row form-fullw">
              <p>1 - KYC Reports are enabled for Business Profiles only</p>
            </div>
          </div>
        </template>
        <div class="buttons">
          <template>
            <button class="main" @click="submit()" :disabled="$v.submitForm.$invalid">Submit</button>
            <button class="second" @click="open = false">Close</button>
          </template>
        </div>
      </div>
    </template>
  </popup>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

import ScanFilters from './filters/ScanFilters'
import AppliedFilters from '../../components/common/AppliedFilters'

export default {
  name: 'ScansModal',

  components: {
    ScanFilters,
    AppliedFilters
  },
  props: {
    modalType: {
      type: String,
      required: true
    },
  },

  data: () => ({
    openedFilters: false,
    filters: null,

    submitForm: {
      profile: null,
      scanType: null
    },
    open: true
  }),

  computed: {
    accountOptions () {
      let registrations = (this.isCustomer ? [this.reg] : this.$store.state.registrations.data) || []
      let accounts = []
      if(this.selectedProvider) {
        registrations.forEach(reg => {
          {
            if(this.selectedProvider.provider_name.includes('KYC Reports')){
            if(reg.type == 'Business') {
              accounts.push({
                id: reg.id,
                text: `${reg.profileNumber}-${reg.name}`,
              })
            }
          }else{
            accounts.push({
              id: reg.id,
              text: `${reg.profileNumber}-${reg.name}`,
            })
          }
          }
        })
      }
      return accounts
    },

    providers () {
      return this.$store.state.providersList.data || []
    },

    selectedProvider() {
      return this.providers.find(item => item.id == this.submitForm.scanType)
    },

    providerOptions () {
      return this.providers.filter(provider => ['Active', 'Testing'].includes(provider.status) && provider.providerType == 'Compliance').map(provider => ({
        id: provider.id,
        text: provider.provider_name
      }))
    },

    isCustomer () {
      return this.currentUser.isCustomer
    },

    currentUser () {
      return window.appData.currentUser
    },
  },

  async created () {

  },

  methods: {
    async submit () {
      const loader = this.$loading.show()
      try {
        const action = (await this.$store.dispatch('scan_reports/action', {
          id: 'new',
          action: 'KycSiteScan',
          payload: {
            provider: this.submitForm.scanType,
            regId: this.submitForm.profile
          }
        })).action
        this.$parent.refreshScans();
      } catch (e) {
        this.$toast.error(window.errorMessage)
      } finally {
        loader.hide()
        this.open = false
      }
    }
  },

  watch: {
    open (open) {
      if (!open) this.$emit('close')
    },
  },

  validations () {
    let rules = {}
    rules = {
      submitForm: {
        profile: { required },
        scanType: { required },
      }
    }

    return rules
  }
}
</script>
<style lang="scss" scoped>
  .buttons {
    margin-top: 270px;
  }
</style>
